import { INeoAction } from '../../Actions.interface';
import { STATUS, REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IExternalParty } from '~/Models/DTO/externalParties.model';
import { keyBy } from 'lodash-es';
import type { Dictionary } from 'lodash';

export interface ExternalPartiesState {
  list: IExternalParty[];
  map: Dictionary<IExternalParty>;
  loading: boolean;
  error: IErrorResponse | null;
}

const INITIAL: ExternalPartiesState = {
  list: [],
  map: {} as any,
  loading: false,
  error: null,
};

export default (
  state: ExternalPartiesState = INITIAL,
  action: INeoAction,
): ExternalPartiesState => {
  const { status, payload, name } = action;

  if (name !== REQUEST_ACTIONS.EXTERNAL_PARTIES) {
    return state;
  }

  switch (status) {
    case STATUS.SUCCESS:
      return {
        list: payload,
        map: keyBy<IExternalParty>(payload, 'id'),
        loading: false,
        error: null,
      };
    case STATUS.FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case STATUS.LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
  }

  return state;
};
